//* Vue Router
import type { RouteRecordRaw } from "vue-router";

//* 站点地图数据校验且处理
const validator_sitemaps = (name: string, datas: RouteRecordRaw[], options: { type: string }) => {
    if (!name.startsWith("./src/sitemaps/")) return [];
    else {
        //* 路由名称规则解析
        const strs = name.split("/").pop()?.replace(".ts", "")?.split("_") || [];
        const changefreq = strs[0];
        const priority = Number(strs[1]);
        const type = strs[2] || "";
        //* 检测是否符合生成站点地图的条件
        if (!changefreq || isNaN(priority) || (options.type != "sitemaps" && options.type != type)) return [];
        else {
            const response: RouteRecordRaw[] = [];
            datas.forEach((route) => {
                response.push(Object.assign(route, { meta: Object.assign(route.meta || {}, { changefreq, priority: priority / 10 }) }));
            });

            return response;
        }
    }
};

export const useRoutes = (extract: string = "ALL") => {
    //* 抓取目录下所有配置文件
    const modules = import.meta.glob("./src/**/*.ts", { eager: true });
    const routes: RouteRecordRaw[] = [];
    //* 遍历配置文件生成路由配置
    for (const key in modules) {
        //* 配置数据
        const datas = (modules[key] as { default?: RouteRecordRaw[] })?.default || [];
        //* 根据 extract 进行不同逻辑的路由提取，文件命名规则为 [changefreq]_[priority]_[type]
        //* - 提取所有路由：ALL
        //* - 提取所有需要生成站点地图的路由：sitemaps
        //* - 提取所有需要生成站点地图且指定 extract 类型的路由：string
        switch (extract) {
            case "ALL":
                datas.forEach((route) => routes.push(route));
                break;
            case "sitemaps":
                routes.push(...validator_sitemaps(key, datas, { type: "sitemaps" }));
                break;
            default:
                routes.push(...validator_sitemaps(key, datas, { type: extract }));
                break;
        }
    }

    return routes;
};
